import { render, staticRenderFns } from "./TerritoryInfo.vue?vue&type=template&id=47e720c6&scoped=true&"
import script from "./TerritoryInfo.vue?vue&type=script&lang=js&"
export * from "./TerritoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./TerritoryInfo.vue?vue&type=style&index=0&id=47e720c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e720c6",
  null
  
)

export default component.exports